import { Mail, MessageCircle, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";

const STATUSES = ["new", "quoted", "confirmed", "completed", "cancelled"];
const COLORS = { new: "#F472B6", quoted: "#F59E0B", confirmed: "#60A5FA", completed: "#34D399", cancelled: "#A8A29E" };

export const OrderCard = ({ order: o, onChange, onDelete }) => {
  const setStatus = async (status) => {
    try {
      const { data } = await api.patch(`/orders/${o.id}`, { status });
      onChange(data);
    } catch (e) {
      toast.error(errorText(e));
    }
  };
  const remove = async () => {
    if (!window.confirm(`Delete order ${o.order_number}?`)) return;
    try {
      await api.delete(`/orders/${o.id}`);
      onDelete(o.id);
    } catch (e) {
      toast.error(errorText(e));
    }
  };
  const digits = (o.phone || "").replace(/\D/g, "");
  const items = Array.isArray(o.items) ? o.items : [];

  return (
    <article className="rounded-3xl border border-white/10 bg-[#261E1B] p-6" data-testid={`admin-order-${o.order_number}`}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="f-mono text-xs tracking-[0.15em] text-[#D6C7C0]">{o.order_number} • {new Date(o.created_at).toLocaleString()}</p>
          <h3 className="f-display mt-1 text-3xl font-semibold text-white">{o.customer_name}</h3>
          <p className="text-sm text-[#D6C7C0]">{o.phone}{o.email ? ` • ${o.email}` : ""}</p>
        </div>
        <select
          value={o.status}
          onChange={(e) => setStatus(e.target.value)}
          data-testid={`admin-status-select-${o.order_number}`}
          className="rounded-full border-0 px-3 py-1.5 text-xs font-semibold capitalize text-[#1A1412] outline-none"
          style={{ background: COLORS[o.status] }}
        >
          {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <p className="mt-4 text-sm text-[#F5EBE6]">
        <span className="capitalize">{o.fulfillment}</span>{o.date_needed ? ` • ${o.date_needed}` : ""}{o.occasion ? ` • ${o.occasion}` : ""}
      </p>
      <ul className="mt-4 space-y-2 border-t border-white/10 pt-4">
        {items.map((i, idx) => (
          <li key={idx} className="flex gap-3 text-sm">
            <span className="f-mono w-10 shrink-0 text-[#F472B6]">{i.qty}×</span>
            <span>
              <span className="text-[#D6C7C0]">{i.category}: </span>{i.name}
              {i.note && <span className="block text-xs italic text-[#D6C7C0]">“{i.note}”</span>}
            </span>
          </li>
        ))}
      </ul>
      {o.notes && <p className="mt-4 rounded-xl bg-white/5 p-3 text-sm text-[#F5EBE6]">{o.notes}</p>}
      <div className="mt-5 flex flex-wrap gap-2">
        <a href={`sms:${digits}`} className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-xs hover:bg-white/10" data-testid={`admin-text-customer-${o.order_number}`}><MessageCircle className="h-3.5 w-3.5" /> Text customer</a>
        {o.email && <a href={`mailto:${o.email}`} className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-xs hover:bg-white/10" data-testid={`admin-email-customer-${o.order_number}`}><Mail className="h-3.5 w-3.5" /> Email customer</a>}
        <button onClick={remove} className="ml-auto flex items-center gap-1.5 rounded-full px-3 py-2 text-xs text-[#FDA4AF] hover:bg-white/5" data-testid={`admin-delete-${o.order_number}`}><Trash2 className="h-3.5 w-3.5" /> Delete</button>
      </div>
    </article>
  );
};
